import React from 'react';

import { AGE_CHART } from 'constants/charts';
import AgeCompareChart from 'components/charts/ButterFlyChart';

const AgeGroupComparisionReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <AgeCompareChart
        titleText="How did each age-group answer the question?"
        subtitleText="Compared to average participants"
        chartType="bar"
        dataType="comparison"
        stacked
        colors={AGE_CHART}
        category="age_range"
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        height={225}
      />
    </div>
  );
};

export default AgeGroupComparisionReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/ageGroupComparisionReport.js